{
  "verified": "Kinnitatud",
  "iv_status": {
    "verified": "Kinnitatud",
    "pending": "Pending",
    "attention": "Tähelepanu"
  },
  "zoom_in": "Suurendage",
  "zoom_out": "Suurendage välja",
  "rotate": "Pöörake",
  "close": "Sulge",
  "esc_to_close": "Vajutage sulgemiseks ESC",
  "play": "Mängi",
  "pause": "Paus",
  "mute": "Mute",
  "unmute": "Unmute",
  "enter_full_screen": "Sisesta täisekraan",
  "exit_full_screen": "Väljumine täisekraanil",
  "video_not_supported": "Teie brauser ei toeta video sildi.",
  "skip_forward": "Hüppa edasi",
  "skip_backward": "Hüppa tagasi",
  "loading": "Laadimine",
  "loading_video": "Video laadimine...",
  "loading_data_description": "Palun oodake, kuni me teie andmeid laadime. See ei võta kaua aega.",
  "no_results": "Tulemusi ei ole",
  "nothing_found": "Midagi ei leitud",
  "save_changes": "Muudatuste salvestamine",
  "saved_exclamation": "Päästetud!",
  "saving": "Säästmine",
  "validating": "Valideerimine",
  "error": "Viga",
  "optional": "Valikuline",
  "search_property": "Otsi kinnisvara",
  "reset_search": "Otsingu lähtestamine",
  "no_items_to_show": "Näidata ei ole esemeid",
  "showing_range_of_total_items": "Näidatakse {{range}} of {{total}} elementide {{range}} kohta",
  "rows_per_page": "Rid lehekülje kohta",
  "page_of_pages": "Lehekülg {{page}} of {{pages}}",
  "go_to_first_page": "Mine esimesele leheküljele",
  "go_to_previous_page": "Mine eelmisele leheküljele",
  "go_to_next_page": "Mine järgmisele leheküljele",
  "go_to_last_page": "Mine viimasele leheküljele",
  "sort_in_asc": "Sorteerimine kasvavas järjekorras",
  "sort_in_desc": "Sorteerimine kahanevas järjekorras",
  "sort_a_z": "Sorte A → Z",
  "sort_z_a": "Sorte Z → A",
  "clear_sorting": "Selge sorteerimine",
  "reach_us_at_email": "Saavutage tugi aadressil support@chekin.com",
  "please_wait": "Palun oodake",
  "feature_coming_soon": "Tulevad varsti",
  "feature_coming_soon_description": "See funktsioon on praegu arendamisel ja on peagi saadaval. Jääge uuenduste osas kursis!",
  "download_all": "Lae alla kõik",
  "entry_forms": "Registreerimisvormid",
  "tutorial": "Tutorial",
  "liveness_video": "Elavuse video",
  "beta": "Beeta",
  "reviews": "Arvustused",
  "learn_more": "Lisateave",
  "this_cannot_be_reverted": "Seda ei saa tagasi pöörata",
  "delete": "Kustuta",
  "cancel": "Tühista",
  "you_have_made_changes": "Te olete teinud muudatusi",
  "would_you_like_to_save_them": "Kas soovite neid päästa?",
  "save": "Salvesta",
  "dont_save": "Ärge salvestage",
  "copied_exclamation": "Kopeeritud!",
  "search_placeholder": "Otsi...",
  "type_to_search": "Kirjutage otsinguks...",
  "loading_more": "Laadimine...",
  "no_options": "Valikud puuduvad",
  "select_option": "Valige valik",
  "clear_all": "Tühjenda kõik",
  "remove_item": "Eemalda {{label}}",
  "upload_file": "Faili üleslaadimine",
  "download_attachment": "Manuse allalaadimine",
  "remove_file": "Eemalda fail",
  "open_calendar": "Avatud kalender",
  "clear_dates": "Selged kuupäevad",
  "select_dates": "Valige kuupäevad",
  "pick_date_range": "Valige kuupäevavahemik",
  "from": "Alates",
  "to": "aadressile",
  "pick_month": "Valige kuu",
  "pick_date": "Valige kuupäev",
  "month": "Kuu",
  "day": "Päev",
  "year": "Aasta",
  "done": "Valmis",
  "wrong_period_of_dates": "Valitud periood on kehtetu",
  "date_range_max_days_error_one": "Vahemik ei tohi ületada {{count}} päeva.",
  "date_range_max_days_error_other": "Vahemik ei tohi ületada {{count}} päeva.",
  "date_range_min_days_error_one": "Vahemik peab olema vähemalt {{count}} päev.",
  "date_range_min_days_error_other": "Vahemik peab olema vähemalt {{count}} päeva",
  "past_dates": "Kuupäev ei saa olla enne {{minDate}}__.",
  "future_dates": "Kuupäev ei saa olla pärast {{maxDate}}__.",
  "signature_placeholder_text": "Kirjutage selle kasti sees.<br/> Kasutage oma sõrme.<br/> Koputage alustamiseks.",
  "open_devices_camera": "Avage seadme kaamera",
  "place_document_inside_frame": "Asetage oma dokument raami sisse",
  "close_other_application_that_may_be_using_your_camera": "Sulgege muud rakendused, mis võivad kasutada teie kaamerat",
  "if_you_use_external_camera_disconnect_and_reconnect": "Kui kasutate välist kaamerat, ühendage see lahti ja ühendage uuesti.",
  "close_the_browser_re_open_it": "Sulgege brauser ja avage see uuesti",
  "camera_errors": {
    "experiencing_camera_issues": "Kas teil on probleeme kaameraga?",
    "chekin_cant_use_your_camera": "Chekin ei saa oma kaamerat kasutada",
    "please_try_a_different_browser": "Teie kaamera ei tööta selles brauseris. Palun proovige avada link teises brauseris.",
    "permissions_denied": "Luba keelatud",
    "camera_permissions_denied": "Kaamera ei avane? Veenduge, et lubate brauserile kaamera kasutamise loa.",
    "no_camera_device_found": "Kaameraseadet ei leitud. Palun ühendage kaamera.",
    "constraints_camera_error": "Olemasolevate seadmetega ei ole võimalik piiranguid täita.",
    "safari_camera_error": "Safari ei suutnud rahuldada kaamera nõudeid",
    "try_chrome_or_firefox": "Palun proovige Chrome'i või Firefoxi"
  },
  "clear": "Selge",
  "show_less": "Näita vähem",
  "show_more": "Näita rohkem",
  "tap_here_to_sign": "Allakirjutamiseks koputage siia",
  "click_here_to_sign": "Allakirjutamiseks klõpsake siin",
  "prefix": "Eesliide",
  "prefix_required": "Vajalik on eesliide",
  "reset": "Reset",
  "show_password": "Näita parooli",
  "hide_password": "Peida parool",
  "increment": "Inkrement",
  "decrement": "Vähendamine",
  "create_option": "Loo \"{{input}}\".",
  "year_out_of_range": "Aasta peab olema {{min}} ja {{max}} vahel.",
  "clear_date": "Selge kuupäev",
  "select_date": "Valige kuupäev",
  "draw_signature_here": "Kirjutage siia oma allkiri",
  "signature_hint": "Kasuta hiirt või sõrme",
  "clear_signature": "Selge allkiri",
  "draw_signature_here_mobile": "Joonista oma allkiri",
  "signature_hint_mobile": "Kasuta sõrme",
  "camera_access_needed": "Vajalik kaamera juurdepääs",
  "camera_access_needed_text": "Luba kaamerale juurdepääs, et saaksid pildi teha. Kui juurdepääs on blokeeritud, luba kaamera kasutamine oma brauseri seadetest ja proovi uuesti.",
  "dialog": "Dialoog"
}
